import React, {useEffect, useState, useMemo} from 'react';
import {useParams, useSearchParams} from 'react-router-dom';
import {EditReward, ViewReward} from './index';
import {getRewardFlowMode} from '@/containers/Rewards/common/utils/getRewardFlowMode';
import {useAppSelector} from '@/store';

/**
 * RewardDetail component - Determines Edit vs View mode based on status
 * This is a router component that decides which flow to render
 */
const RewardDetail = () => {
  const {id} = useParams();
  const [searchParams] = useSearchParams();
  const VALID_STATUSES = ['draft', 'published', 'in progress', 'revoked'];
  const rawStatus = searchParams.get('status');
  const statusFromQuery = VALID_STATUSES.includes(rawStatus?.toLowerCase())
    ? rawStatus
    : null;
  const formData = useAppSelector((state) => state.rewards.formData);

  const initialMode = useMemo(() => {
    if (!statusFromQuery) return null;
    return getRewardFlowMode(id, statusFromQuery);
  }, [id, statusFromQuery]);

  const [mode, setMode] = useState(initialMode || 'edit');

  // Determine mode based on loaded reward status or query param
  useEffect(() => {
    if (statusFromQuery) return;
    if (!id) return;
    if (String(formData?.rewardId) !== String(id)) return;
    const determinedMode = getRewardFlowMode(id, formData?.status);
    setMode(determinedMode);
  }, [id, formData?.rewardId, formData?.status, statusFromQuery]);

  // Memoize the rendered component based on mode to prevent unnecessary re-renders
  const renderedComponent = useMemo(() => {
    if (mode === 'view') {
      return <ViewReward />;
    }
    return <EditReward />;
  }, [mode]);

  return renderedComponent;
};

export default RewardDetail;
